<template>
    <div class='input-cnt'>
        <div class='sub-line'>
            <div class='com-radio'>
                <input :id="id+'-1'" v-model='data' :name='id' :value='false' checked type='radio' />
                <label :for="id+'-1'">부가세를 제외하지 않습니다.</label>
            </div>
        </div>
        <div class='sub-line'>
            <div class='com-radio'>
                <input :id="id+'-2'" v-model='data' :name='id' :value='true' type='radio' />
                <label :for="id+'-2'">부가세 10%를 제외하고 정산합니다.</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingEmployeeSalaryVat',
    props: ['value', 'id'],
    data() {
        return {
            data: false,
        };
    },
    created() {

        this.data = this.value;
    },
    watch: {
        value(v){
            this.data = v;
        }
        ,
        data(v) {
            this.$emit('input', v);
        },
    },
};
</script>
